import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertInternalAuditImpactRatingMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertInternalAuditImpactRatingDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type InsertImpactInternalAuditRatingInput = {
  InternalAuditReportId: string;
  RatedItemId: string;
  Ratings: { ImpactId: string; Rating: number }[];
  TestDate: string;
  CompletedBy?: string | null;
  Likelihood?: number | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertImpactInternalAuditRating = createMutationHook({
  name: 'insertImpactInternalAuditRating',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.internalAuditResult.insertImpactRating.mutationOptions({
      onSuccess,
    }),
  mapInput: (input: InsertImpactInternalAuditRatingInput) => input,
  mapResponse: (result: {
    Ids: string[];
  }): InsertInternalAuditImpactRatingMutation => ({
    insertChildImpactInternalAuditRating: {
      __typename: 'insertChildImpactRatingOutput',
      Ids: result.Ids,
    },
  }),
  invalidate: (trpc) => [
    trpc.frontend.internalAuditResult.pathKey(),
    trpc.frontend.assessment.internalAuditResultCount.queryKey(),
    // COI-471 parity: Apollo twin also evicts `internal_audit_report`.
    trpc.frontend.internalAuditReport.pathKey(),
  ],
  graphqlDocument: InsertInternalAuditImpactRatingDocument,
  graphqlVariables: (input: InsertImpactInternalAuditRatingInput) => ({
    ...input,
  }),
  evictFields: ['impact_internal_audit_rating', 'internal_audit_report'],
});
